import React, { useState } from 'react';
import Manager from '../../../commonComponents/Manager';
import { CompanyNameType } from '../../../../static/types/commonTypes/companyNameType';
import { ManagerType } from '../../../../static/types/commonTypes/managerType';
import { ToastContainer } from 'react-toastify';
import useAppContext from '../../../../hooks/useAppContext';
import { AppContextType, CapitalType } from '../../../../context/AppContext';
import { SigningOfTheStatusType } from '../../../../static/types/commonTypes/signingOfTheStatusType';
import { getCityWithPreposition } from '../../../../utils/functions/getCityWithPreposition';
import { TaxServiceRegistrationType } from '../../../../static/types/commonTypes/taxServiceRegistrationType';
import { DateType } from '../../../../static/types/commonTypes/dateType';
import { RegistrationNoticesType } from '../../../../static/types/commonTypes/registrationNoticesType';
import { AddressType } from '../../../../static/types/commonTypes/addressType';
import CompanyName from '../../../commonComponents/CompanyName';
import SigningOfTheStatus from '../../../commonComponents/SigningOfTheStatus';
import TaxServiceRegistration from '../../../commonComponents/TaxServiceRegistration';
import RegistrationNotices from '../cessionDroitDeBail/RegistrationNotices';
import Address from '../../../commonComponents/Address';
import CapitalChange from '../../../commonComponents/CapitalChange';
import DateComponent from '../../../commonComponents/DateComponent';
import AddressPlaceOppositions from '../cessionDroitDeBail/AddressPlaceOppositions';
import TextArea from '../../../commonComponents/TextArea';
import { SlArrowLeft, SlArrowRight } from "react-icons/sl";
import { FaUpload } from 'react-icons/fa';
import { GoArrowRight } from 'react-icons/go';
import { optionalTextAreaValidationSchema, requiredTextAreaValidationSchema } from '../../../../utils/validation/textAreaValidationSchema';
import { formatObjectText } from '../../../../utils/functions/formatObjectText';

interface AnnonceProps {
    txtAnnonce: string;
    updateActiveIndex: (index: number) => void;
    updateTxtAnnonce: (newTxt: string) => void;
    updateDenomination: (newTxt: string) => void;
    societyType: string | string[];
    societeSelected: string;
    updatesocieteSelected: (newTxt: string) => void;

}

const CessionFondCommerce: React.FC<AnnonceProps> = ({
    txtAnnonce,
    updateTxtAnnonce,
    updateActiveIndex,
    updateDenomination,
    societyType,
    updatesocieteSelected
}) => {


    const {

        companyName, setCompanyName,
        companyNameValidity, setCompanyNameValidity,
        companyNameChecked, setCompanyNameChecked,

        signingOfTheStatus,
        setSigningOfTheStatus,
        signingOfTheStatusValidity,
        setSigningOfTheStatusValidity,
        signingOfTheStatusChecked,
        setSigningOfTheStatusChecked,

        taxServiceRegistration,
        setTaxServiceRegistration,
        taxServiceRegistrationValidity,
        setTaxServiceRegistrationValidity,
        taxServiceRegistrationChecked,
        setTaxServiceRegistrationChecked,

        address,
        setAddress,
        addressValidity,
        setAddressValidity,
        addressChecked,
        setAddressChecked,

        transfertAmount,
        setTransfertAmount,
        transfertAmountValidity,
        setTransfertAmountValidity,
        transfertAmountChecked,
        setTransfertAmountChecked,

        date,
        setDate,
        dateValidity,
        setDateValidity,
        dateChecked,
        setDateChecked,

        registrationDate,
        setRegistrationDate,
        registrationDateValidity,
        setRegistrationDateValidity,
        registrationDateChecked,
        setRegistrationDateChecked,

        registrationNotices, setRegistrationNotices,
        registrationNoticesValidity, setRegistrationNoticesValidity,
        registrationNoticesChecked, setRegistrationNoticesChecked,

        typeRegistrationData,


        // cédant
        sellerManager, setSellerManager,
        sellerManagerValidity, setSellerManagerValidity,
        sellerManagerChecked, setSellerManagerChecked,

        // acquéreur
        buyerManager, setBuyerManager,
        buyerManagerValidity, setBuyerManagerValidity,
        buyerManagerChecked, setBuyerManagerChecked,

        typeOppositionData,
        setTypeOppositionData,

        locationOppositionsRegistry,
        setLocationOppositionsRegistry,
        locationOppositionsRegistryValidity,
        setLocationOppositionsRegistryValidity,
        locationOppositionsRegistryChecked,
        setLocationOppositionsRegistryChecked,

        validityOppositionLocation,
        setValidityOppositionLocation,
        validityOppositionLocationValidity,
        setValidityOppositionLocationValidity,
        validityOppositionLocationChecked,
        setValidityOppositionLocationChecked,

        // activité du fonds
        fundActivity, setFundActivity,
        fundActivityValidity, setFundActivityValidity,
        fundActivityChecked, setFundActivityChecked,

        // actéléments du fonds
        fundElements, setFundElements,
        fundElementsValidity, setFundElementsValidity,
        fundElementsChecked, setFundElementsChecked,

    } = useAppContext() as AppContextType

    const [activeTab, setActiveTab] = useState<string>('companyName');
    const [visitedTabs, setVisitedTabs] = useState(['companyName']);
    const [submissive, setSubmissive] = useState<boolean>(false);
    const societyTypeOptions = Array.isArray(societyType) ? societyType : [societyType];

    const handleSubmit = (e: React.FormEvent) => {

        e.preventDefault();

        if (validate()) {

            const statusSignatureText = (statusSignature: SigningOfTheStatusType): string => {
                let res = ``
                if (statusSignature.actNature === "acte sous seing privé") res = `Par acte SSP du`
                else res = `Par acte authentique du`
                return `${res} ${statusSignature.actDate}${statusSignature.placeSignature ? ` à ${statusSignature.placeSignature}` : ""}`
            }

            const taxRegistrationText = (taxtRegistrationService: TaxServiceRegistrationType): string => {
                let res = ``
                if (taxtRegistrationService.taxService.includes("(SIE)")) res = `enregistré au SIE`
                else res = `enregistré au SDE`
                return `${res} ${getCityWithPreposition(taxtRegistrationService.taxVille)}`
            }

            const registrationNoticesText = (date: DateType, registrationNotice: RegistrationNoticesType): string => {
                let res = ``
                if (registrationNotice.numberProvided === "bordereau") {
                    res = `le ${date.date}, Bordereau no ${registrationNotice.bordereau?.numeroBordereau}, Case no ${registrationNotice.bordereau?.numeroCase} ${registrationNotice.bordereau?.numeroExtrait ? `, ext ${registrationNotice.bordereau?.numeroExtrait}` : ''}`
                }
                else if (registrationNotice.numberProvided === "dossier") {
                    res = `le ${date.date}, Dossier no ${registrationNotice.dossier?.numeroDossier} ${registrationNotice.dossier?.numeroReference ? `, Référence ${registrationNotice.dossier?.numeroReference}` : ''}`
                }
                return res
            }

            const managerText = (manager: ManagerType): string => {
                if (manager.person === "Personne morale") {
                    return ` ${manager.entityDetails.companyName}, ${manager.entityDetails.legalForm} au capital de ${manager.entityDetails.capital} €, ayant son siège social ${manager.entityDetails.address} ${manager.entityDetails.additionalAddress ?? ""} ${manager.entityDetails.postalCode} ${manager.entityDetails.city}, ${manager.entityDetails.isRcsRegistering ? `en cours d'immatriculation au RCS ${getCityWithPreposition(manager.entityDetails.registrationOffice)}` : `${manager.entityDetails.rcs} RCS ${getCityWithPreposition(manager.entityDetails.registrationOffice)}`} `
                }
                else if (manager.person === "Personne physique") {
                    return manager.personDetails.lastName ? ` ${manager.personDetails.civility === 'Monsieur' ? 'M.' : 'Mme'} ${manager.personDetails.lastName} ${manager.personDetails.firstName}, demeurant ${manager.personDetails.address} ${manager.personDetails.additionalAddress ?? ""} ${manager.personDetails.postalCode} ${manager.personDetails.city}` : ``
                }
                else return ""
            }

            const entryDateText = (date: DateType): string => {
                return `Date d'entrée en jouissance : ${date.date}`
            }

            const oppositionLocationText = (correspodenceAddress: AddressType, validityAddress: AddressType, isSameAddress: number): string => {
                let res = ``
                if (isSameAddress === 0) {
                    res = `Les oppositions sont reçues dans les 10 jours de la dernière date des publicités légales à l'adresse suivante : ${correspodenceAddress.address} ${correspodenceAddress.additionalAddress ? `${correspodenceAddress.additionalAddress}` : ''} - ${correspodenceAddress.postalCode} ${correspodenceAddress.city}.`
                }
                else if (isSameAddress === 1) {
                    res = `Les oppositions sont reçues dans les 10 jours de la dernière date des publicités légales aux adresses suivantes : ${correspodenceAddress.address} ${correspodenceAddress.additionalAddress ? `${correspodenceAddress.additionalAddress}` : ''} - ${correspodenceAddress.postalCode} ${correspodenceAddress.city} pour la correspondance et ${validityAddress.address} ${validityAddress.additionalAddress ? `${validityAddress.additionalAddress}` : ''} - ${validityAddress.postalCode} ${validityAddress.city}pour la validité.`
                }
                return res
            }

            e.preventDefault();

            const tempText = `${statusSignatureText(signingOfTheStatus)}, ${taxRegistrationText(taxServiceRegistration)}, ${registrationNoticesText(registrationDate, registrationNotices)},
${managerText(sellerManager)},
A cédé à
${managerText(buyerManager)}, un fonds de commerce de ${fundActivity.value}, comprenant ${fundElements.value}, sis ${address.additionalAddress}${address.additionalAddress ? address.additionalAddress : ""} ${address.postalCode} ${address.city}, moyennant le prix de ${transfertAmount.capital} €.
${entryDateText(date)},
${oppositionLocationText(locationOppositionsRegistry, validityOppositionLocation, typeOppositionData)}
`

            const formattedText = formatObjectText(tempText);
            updateTxtAnnonce(formattedText);
            updateDenomination(companyName.companyName);
            setSubmissive(true)
        }

    };

    const validate = () => {
        if (!companyNameValidity) {
            setActiveTab('companyName')
        } else if (!signingOfTheStatusValidity) {
            setActiveTab('signingOfTheStatus')
        } else if (!taxServiceRegistrationValidity) {
            setActiveTab('taxServiceRegistration')
        } else if (!(registrationDateValidity && registrationNoticesValidity)) {
            setActiveTab('registrationNotices')
        } else if (!sellerManagerValidity) {
            setActiveTab('transferor')
        } else if (!buyerManagerValidity) {
            setActiveTab('purchaser')
        } else if (!fundActivityValidity) {
            setActiveTab('fundActivity')
        } else if (!addressValidity) {
            setActiveTab('address')
        } else if (!fundElementsValidity) {
            setActiveTab('fundElements')
        } else if (!transfertAmountValidity) {
            setActiveTab('amountTransfer')
        } else if (!dateValidity) {
            setActiveTab('dateEntryEnjoyment')
        } else if (typeOppositionData === 0) {
            if (!locationOppositionsRegistryValidity)
                setActiveTab('addressPlaceOppositions')
        } else if (typeOppositionData === 1) {
            if (!(locationOppositionsRegistryValidity && validityOppositionLocationValidity))
                setActiveTab('addressPlaceOppositions')
        }

        let temp_registrationNotivesValidity = registrationDateValidity && registrationNoticesValidity

        let temp_oppositionLocationValidity = typeOppositionData === 0
            ? locationOppositionsRegistryValidity
            : locationOppositionsRegistryValidity && validityOppositionLocationValidity

        return companyNameValidity && signingOfTheStatusValidity && taxServiceRegistrationValidity && temp_registrationNotivesValidity && sellerManagerValidity && buyerManager && addressValidity && transfertAmountValidity && dateValidity && temp_oppositionLocationValidity;

    };

    const handleNext = () => {
        if (activeTab === "companyName") {
            setCompanyNameChecked(true)
            if (companyNameValidity) {
                switchTab(getNextTab("companyName"));
            }
        } else if (activeTab === "signingOfTheStatus") {
            setSigningOfTheStatusChecked(true)
            if (signingOfTheStatusValidity) {
                switchTab(getNextTab("signingOfTheStatus"));
            }
        } else if (activeTab === "taxServiceRegistration") {
            setTaxServiceRegistrationChecked(true)
            if (taxServiceRegistrationValidity) {
                switchTab(getNextTab("taxServiceRegistration"));
            }
        } else if (activeTab === "registrationNotices") {
            if (typeRegistrationData === 'bordereau' || typeRegistrationData === 'dossier') {
                setRegistrationDateChecked(true)
                setRegistrationNoticesChecked(true)
                if (registrationDateValidity && registrationNoticesValidity) {
                    switchTab(getNextTab("registrationNotices"))
                }
            }
        } else if (activeTab === "transferor") {
            setSellerManagerChecked(true)
            if (sellerManagerValidity) {
                switchTab(getNextTab("transferor"))
            }
        } else if (activeTab === "purchaser") {
            setBuyerManagerChecked(true)
            if (buyerManagerValidity) {
                switchTab(getNextTab("purchaser"))
            }
        } else if (activeTab === "fundActivity") {
            setFundActivityChecked(true)
            if (fundActivityValidity) {
                switchTab(getNextTab("fundActivity"))
            }
        } else if (activeTab === "address") {
            setAddressChecked(true)
            if (addressValidity) {
                switchTab(getNextTab("address"))
            }
        } else if (activeTab === "fundElements") {
            setFundElementsChecked(true)
            if (fundElementsValidity) {
                switchTab(getNextTab("fundElements"))
            }
        } else if (activeTab === "amountTransfer") {
            setTransfertAmountChecked(true)
            if (transfertAmountValidity) {
                switchTab(getNextTab("amountTransfer"))
            }
        } else if (activeTab === "dateEntryEnjoyment") {
            setDateChecked(true)
            if (dateValidity) {
                switchTab(getNextTab("dateEntryEnjoyment"))
            }
        } else if (activeTab === "addressPlaceOppositions") {
            setLocationOppositionsRegistryChecked(true)
            if (typeOppositionData === 1) {
                setValidityOppositionLocationChecked(true)
                if (locationOppositionsRegistryValidity && validityOppositionLocationValidity) {
                    setSubmissive(true)
                }
            }
            else {
                if (locationOppositionsRegistryValidity) {
                    setSubmissive(true)
                }
            }
        }
    };

    const handlePrevious = () => {
        switchTab(getPreviousTab(activeTab));
        setSubmissive(false)
    };

    const switchTab = (tab: string) => {
setActiveTab(tab);
    };

    const getNextTab = (currentTab: string) => {
        if (currentTab === "companyName") return "signingOfTheStatus";
        else if (currentTab === "signingOfTheStatus") return "taxServiceRegistration";
        else if (currentTab === "taxServiceRegistration") return "registrationNotices";
        else if (currentTab === "registrationNotices") return "transferor";
        else if (currentTab === "transferor") return "purchaser";
        else if (currentTab === "purchaser") return "fundActivity";
        else if (currentTab === "fundActivity") return "address";
        else if (currentTab === "address") return "fundElements";
        else if (currentTab === "fundElements") return "amountTransfer";
        else if (currentTab === "amountTransfer") return "dateEntryEnjoyment";
        else if (currentTab === "dateEntryEnjoyment") return "addressPlaceOppositions";
        else return currentTab;
    }

    const getPreviousTab = (currentTab: string) => {
        if (currentTab === "addressPlaceOppositions") return "dateEntryEnjoyment";
        else if (currentTab === "dateEntryEnjoyment") return "amountTransfer";
        else if (currentTab === "amountTransfer") return "fundElements";
        else if (currentTab === "fundElements") return "address";
        else if (currentTab === "address") return "fundActivity";
        else if (currentTab === "fundActivity") return "purchaser";
        else if (currentTab === "purchaser") return "transferor";
        else if (currentTab === "transferor") return "registrationNotices";
        else if (currentTab === "registrationNotices") return "taxServiceRegistration";
        else if (currentTab === "taxServiceRegistration") return "signingOfTheStatus";
        else if (currentTab === "signingOfTheStatus") return "companyName";
        else return currentTab;
    }

    const goToSupportPresse = () => {
        updateActiveIndex(2);
    }

    const updateCompanyName = (data: Partial<CompanyNameType>) => setCompanyName({ ...companyName, ...data });
    const updateSigning = (data: Partial<SigningOfTheStatusType>) => setSigningOfTheStatus({ ...signingOfTheStatus, ...data })
    const updateTaxService = (data: Partial<TaxServiceRegistrationType>) => setTaxServiceRegistration({ ...taxServiceRegistration, ...data })
    const updateAddress = (partialAddress: Partial<AddressType>) => setAddress({ ...address, ...partialAddress })
    const updateDate = (data: Partial<DateType>) => setDate({ ...date, ...data });
    const tabs =[
        {key: 'companyName', label: 'Raison Sociale'},
        {key: 'signingOfTheStatus', label: 'Acte de cession de fonds'},
        {key: 'taxServiceRegistration', label: 'Enregistrement du service des impôts'},
        {key: 'registrationNotices', label: "Mention d'enregistrement"},
        {key: 'transferor', label: 'Cédant'},
        {key: 'purchaser', label: 'Acquéreur'},
        {key: 'fundActivity', label: "L'activité du fonds"},
        {key: 'address', label: "L'adresse du fonds"},
        {key: 'fundElements', label: 'Eléments du fonds'},
        {key: 'amountTransfer', label: 'Montant de la cession'},
        {key: 'dateEntryEnjoyment', label: "Date d'entrée en jouissance"},
        {key: 'addressPlaceOppositions', label: 'Adresse du lieu des oppositions'},
        // {key: 'bodacc', label: 'Publication au BODACC'},
    ]

    return (
        <>
            <div className='container my-3'>
                <ul className="nav nav-underline">
                    <li className="nav-item">
                        <a
                            href='#companyName'
                            className={`nav-link ${activeTab === 'companyName' ? 'active' : ''}`}
                            onClick={() => visitedTabs.includes('companyName') && switchTab('companyName')}
                        >
                            Raison Sociale
                        </a>
                    </li>
                    <li className="nav-item">
                        <a
                            href='#signingOfTheStatus'
                            className={`nav-link ${activeTab === 'signingOfTheStatus' ? 'active' : ''} ${!visitedTabs.includes('signingOfTheStatus') ? 'disabled' : ''}`}
                            onClick={() => visitedTabs.includes('signingOfTheStatus') && switchTab('signingOfTheStatus')}
                        >
                            Acte de cession de fonds
                        </a>
                    </li>
                    <li className="nav-item">
                        <a
                            href='#taxServiceRegistration'
                            className={`nav-link ${activeTab === 'taxServiceRegistration' ? 'active' : ''} ${!visitedTabs.includes('taxServiceRegistration') ? 'disabled' : ''}`}
                            onClick={() => visitedTabs.includes('taxServiceRegistration') && switchTab('taxServiceRegistration')}
                        >
                            Enregistrement du service des impôts
                        </a>
                    </li>
                    <li className="nav-item">
                        <a
                            href='#registrationNotices'
                            className={`nav-link ${activeTab === 'registrationNotices' ? 'active' : ''} ${!visitedTabs.includes('registrationNotices') ? 'disabled' : ''}`}
                            onClick={() => visitedTabs.includes('registrationNotices') && switchTab('registrationNotices')}
                        >
                            Mention d'enregistrement
                        </a>
                    </li>
                    <li className="nav-item">
                        <a
                            href='#transferor'
                            className={`nav-link ${activeTab === 'transferor' ? 'active' : ''} ${!visitedTabs.includes('transferor') ? 'disabled' : ''}`}
                            onClick={() => visitedTabs.includes('transferor') && switchTab('transferor')}
                        >
                            Cédant
                        </a>
                    </li>
                    <li className="nav-item">
                        <a
                            href='#purchaser'
                            className={`nav-link ${activeTab === 'purchaser' ? 'active' : ''} ${!visitedTabs.includes('purchaser') ? 'disabled' : ''}`}
                            onClick={() => visitedTabs.includes('purchaser') && switchTab('purchaser')}
                        >
                            Acquéreur
                        </a>
                    </li>
                    <li className="nav-item">
                        <a
                            href='#fundActivity'
                            className={`nav-link ${activeTab === 'fundActivity' ? 'active' : ''} ${!visitedTabs.includes('fundActivity') ? 'disabled' : ''}`}
                            onClick={() => visitedTabs.includes('fundActivity') && switchTab('fundActivity')}
                        >
                            L'activité du fonds
                        </a>
                    </li>
                    <li className="nav-item">
                        <a
                            href='#address'
                            className={`nav-link ${activeTab === 'address' ? 'active' : ''} ${!visitedTabs.includes('address') ? 'disabled' : ''}`}
                            onClick={() => visitedTabs.includes('address') && switchTab('address')}
                        >
                            L'adresse du fonds
                        </a>
                    </li>
                    <li className="nav-item">
                        <a
                            href='#fundElements'
                            className={`nav-link ${activeTab === 'fundElements' ? 'active' : ''} ${!visitedTabs.includes('fundElements') ? 'disabled' : ''}`}
                            onClick={() => visitedTabs.includes('fundElements') && switchTab('fundElements')}
                        >
                            Eléments du fonds
                        </a>
                    </li>
                    <li className="nav-item">
                        <a
                            href='#amountTransfer'
                            className={`nav-link ${activeTab === 'amountTransfer' ? 'active' : ''} ${!visitedTabs.includes('amountTransfer') ? 'disabled' : ''}`}
                            onClick={() => visitedTabs.includes('amountTransfer') && switchTab('amountTransfer')}
                        >
                            Montant de la cession
                        </a>
                    </li>
                    <li className="nav-item">
                        <a
                            href='#dateEntryEnjoyment'
                            className={`nav-link ${activeTab === 'dateEntryEnjoyment' ? 'active' : ''} ${!visitedTabs.includes('dateEntryEnjoyment') ? 'disabled' : ''}`}
                            onClick={() => visitedTabs.includes('dateEntryEnjoyment') && switchTab('dateEntryEnjoyment')}
                        >
                            Date d'entrée en jouissance
                        </a>
                    </li>
                    <li className="nav-item">
                        <a
                            href='#addressPlaceOppositions'
                            className={`nav-link ${activeTab === 'addressPlaceOppositions' ? 'active' : ''} ${!visitedTabs.includes('addressPlaceOppositions') ? 'disabled' : ''}`}
                            onClick={() => visitedTabs.includes('addressPlaceOppositions') && switchTab('addressPlaceOppositions')}
                        >
                            Adresse du lieu des oppositions
                        </a>
                    </li>
                    {/* <li className="nav-item">
                        <a
                            href= ' '
                            className={`nav-link ${activeTab === 'bodacc' ? 'active' : ''} ${!visitedTabs.includes('bodacc') ? 'disabled' : ''}`}
                            onClick={() => visitedTabs.includes('bodacc') && switchTab('bodacc')}
                        >
                            Publication au BODACC
                        </a>
                    </li> */}
                </ul>
            </div>

            <ToastContainer />

            <form onSubmit={handleSubmit}>
                {
                    activeTab === 'companyName' &&
                    <div>
                        <span className='mb-2'>
                            Indiquer la raison sociale de la société ou la dénomination du Cabinet de Notaire annonceur ou l'état civil de la personne concernée par l'annonce, en optionnel vous pouvez ajouter une référence client.
                        </span>
                        <div className="tab-content">
                            <CompanyName
                                changeCompanyName={updateCompanyName}
                                checked={companyNameChecked}
                                companyName={companyName}
                                onValidationChange={(isValid: boolean) => setCompanyNameValidity(isValid)}
                                showClientReference={true}
                            />
                        </div>
                    </div>
                }

                {
                    activeTab === 'signingOfTheStatus' &&
                    <SigningOfTheStatus
                        actDateLabel="Date de l'acte"
                        actNature={[
                            "acte sous seing privé",
                            "acte authentique"
                        ]}
                        checked={signingOfTheStatusChecked}
                        signingOfTheStatus={signingOfTheStatus}
                        updateSigningOfTheStatus={updateSigning}
                        showPlaceSignature={true}
                        onValidationChange={(isValid: boolean) => setSigningOfTheStatusValidity(isValid)}
                    />
                }

                {
                    activeTab === 'taxServiceRegistration' &&
                    <TaxServiceRegistration
                        checked={taxServiceRegistrationChecked}
                        taxServiceRegistration={taxServiceRegistration}
                        updateTaxServiceRegistration={updateTaxService}
                        onValidationChange={(isValid: boolean) => setTaxServiceRegistrationValidity(isValid)}
                        taxServiceOption={[
                            "Service des impôts des entreprises (SIE)",
                            "Service départemental des Enregistrements (SDE)"
                        ]}
                    />
                }

                {
                    activeTab === 'registrationNotices' &&
                    <RegistrationNotices />
                }

                {
                    activeTab === 'transferor' &&
                    <Manager
                        checked={sellerManagerChecked}
                        manager={sellerManager}
                        setChecked={setSellerManagerChecked}
                        updateManagerValidity={setSellerManagerValidity}
                        setManager={setSellerManager}
                        showRcsCheckBox={true}
                        societyType={societyTypeOptions}
                        draftFieldName = 'sellerManager'
                    />
                }

                {
                    activeTab === 'purchaser' &&
                    <Manager
                        checked={buyerManagerChecked}
                        manager={buyerManager}
                        setChecked={setBuyerManagerChecked}
                        updateManagerValidity={setBuyerManagerValidity}
                        setManager={setBuyerManager}
                        showRcsCheckBox={true}
                        societyType={societyTypeOptions}
                        draftFieldName = 'buyerManager'
                    />
                }

                {
                    activeTab === 'fundActivity' &&
                    <TextArea
                        checked={fundActivityChecked}
                        label='Activité'
                        required={true}
                        text={fundActivity}
                        updateText={setFundActivity}
                        updateValidity={setFundActivityValidity}
                        validationSchema={requiredTextAreaValidationSchema("L'activité du fonds est requise")}
                    />
                }

                {
                    activeTab === 'address' &&
                    <Address
                        checked={addressChecked}
                        address={address}
                        draftFieldName = 'address'
                        changeAddress={updateAddress}
                        onValidationChange={(isValid: boolean) => setAddressValidity(isValid)}
                    />
                }

                {
                    activeTab === 'fundElements' &&
                    <TextArea
                        checked={fundElementsChecked}
                        label='Eléments'
                        required={true}
                        text={fundElements}
                        updateText={setFundElements}
                        updateValidity={setFundElementsValidity}
                        validationSchema={requiredTextAreaValidationSchema("Les éléments du fonds sont requis")}
                    />
                }

                {
                    activeTab === 'amountTransfer' &&
                    <CapitalChange
                        inputLabel='Montant en euros'
                        fieldKey='transfertAmount'
                        checked={transfertAmountChecked}
                        capital={transfertAmount}
                        onChange={(data: Partial<CapitalType>) => setTransfertAmount({ ...transfertAmount, ...data })}
                        onValidationChange={(isValid: boolean) => setTransfertAmountValidity(isValid)}
                    />
                }

                {
                    activeTab === 'dateEntryEnjoyment' &&
                    <div className="col-md-6">
                        <DateComponent
                            dateLabel="Date d'effet"
                            date={date}
                            checked={dateChecked}
                            changeDate={updateDate}
                            required={true}
                            onValidationChange={(isValid: boolean) => setDateValidity(isValid)}
                            id="dateEntryEnjoyment"
                        />
                    </div>
                }

                {
                    activeTab === 'addressPlaceOppositions' &&
                    <AddressPlaceOppositions />
                }

                {
                    submissive &&
                    activeTab === 'addressPlaceOppositions' &&
                    <div className="mt-4">
                        <h4>Texte de l'annonce:</h4>
                        <textarea
                            className="form-control"
                            rows={5}
                            value={txtAnnonce}
                            disabled
                        />
                    </div>
                }

                <div className="button-container">
                    <div className="d-flex gap-2">
                        {
                            activeTab !== 'companyName' && (
                                <button color="#F4A261"
                                    className="btn-add"
                                    type="button"
                                    onClick={handlePrevious} >
                                    <SlArrowLeft className="icon" style={{ marginRight: '10px', fontSize: '20px' }} />
                                    Modifier mon annonce
                                </button>
                            )}

                        {
                            activeTab === 'addressPlaceOppositions' && (
                                <button type="submit"
                                    onClick={handleNext}>
                                    Mettre à jour mon annonce
                                    <FaUpload className="icon" style={{ marginLeft: '15px', fontSize: '20px' }} />
                                </button>
                            )}

                        {
                            activeTab !== 'addressPlaceOppositions' && (
                                <button color="#F4A261"
                                    className="btn-add"
                                    type="button"
                                    onClick={handleNext} >
                                    Suivant
                                    <SlArrowRight className="icon" style={{ marginLeft: '10px', fontSize: '20px' }} />
                                </button>
                            )}

                        {
                            submissive && activeTab === 'addressPlaceOppositions' && (
                                <button color="#F4A261"
                                    className="btn-add"
                                    type="button"
                                    onClick={goToSupportPresse} >
                                    Sélection du support
                                    <GoArrowRight className="icon" style={{ marginLeft: '10px', fontSize: '20px' }} />
                                </button>
                            )}
                    </div>
                </div>
            </form>
        </>
    );
};

export default CessionFondCommerce;